export default function createDialogPalette(theme, current, base) {
    return {
        dialog: {
            dialog: {
                backgroundColor: base.background,
            },
            header: {
                borderBottomColor: base.gray[200],
            },
        },
    };
}
//# sourceMappingURL=dialog.js.map